import React, { useRef, useState } from 'react'
import { Box, Stack, SxProps, TableCell, Tooltip, Typography } from '@mui/material'
import Info from '../../assets/icons/InfoIcon'

interface Props {
    details: string
    displayPurpose: string
}

type Purpose = string

const tableCellProps: SxProps = {
    padding: '8px'
}

const PurposeTableCell: React.FC<Props> = ({ details, displayPurpose }) => {
    const [showInfo, setShowInfo] = useState(false)
    const cellRef = useRef(null)
    const purpose = displayPurpose

    const handleMouseEnter = () => {
        setShowInfo(true)
    }

    const handleMouseLeave = () => {
        setShowInfo(false)
    }

    return (
        <TableCell sx={{ ...tableCellProps }} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} ref={cellRef}>
            <Stack direction="row" alignItems="center" spacing={1}>
                <Typography
                    variant="body2"
                    sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }}
                >
                    {purpose}
                </Typography>

                {showInfo && (
                    <Tooltip title={details} placement="top" arrow>
                        <Box sx={{ display: 'inline-flex', alignItems: 'center', color: 'text.disabled', cursor: 'pointer' }}>
                            <Info fontSize="small" />
                        </Box>
                    </Tooltip>
                )}
            </Stack>
        </TableCell>
    )
}

export default PurposeTableCell
